import React from 'react';

const Edu = () => (
    <div className="edu">
        <strong>Civilingenjör Elektroteknik</strong><br/><i>1999 - 2004, Lunds tekniska högskola</i>
    </div>
);

export default Edu;
